import { useAccountScope } from '../context/AccountScope';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import VehiclePhotoEditor from './VehiclePhotoEditor/VehiclePhotoEditor';

function DevicesAdminPage() {
  const { fetch, account: scopeAccount } = useAccountScope();
  const [isMobile, setIsMobile] = useState(() => isMobileLayout());
  useEffect(() => {
    const check = () => setIsMobile(isMobileLayout());
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  const user =
    scopeAccount;

  const [modalOpen, setModalOpen] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [photoFile, setPhotoFile] = useState(null);
const [photoPreview, setPhotoPreview] = useState('');
const [photoEditorOpen, setPhotoEditorOpen] = useState(false);

const [editPhotoRemoved, setEditPhotoRemoved] = useState(false);
const [form, setForm] = useState({
  name: '',
  imei: '',
  plate: '',
  protocol: '',
  company_id: '',
  admin_id: '',
  user_id: ''
});
  useEffect(() => {
    cargarDatos();
    cargarDispositivos();
  }, []);


  const [editModalOpen, setEditModalOpen] = useState(false);
const [editingDevice, setEditingDevice] = useState(null);

const [editForm, setEditForm] = useState({
  name: '',
  imei: '',
  plate: '',
  protocol: '',
  company_id: '',
  admin_id: '',
  user_id: ''
});

const [editPhotoFile, setEditPhotoFile] = useState(null);
const [editPhotoPreview, setEditPhotoPreview] = useState('');
const [editPhotoEditorOpen, setEditPhotoEditorOpen] = useState(false);

  async function cargarDatos() {
    try {
      const token = localStorage.getItem('token');

      const usersRes = await fetch('/api/users', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const usersData = await usersRes.json();

      if (Array.isArray(usersData)) {
        setUsuarios(usersData);
      }

      if (Array.isArray(usersData.users)) {
        setUsuarios(usersData.users);
      }

      const companiesRes = await fetch('/api/companies', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const companiesData = await companiesRes.json();

      if (Array.isArray(companiesData)) {
        setEmpresas(companiesData);
      }

      if (Array.isArray(companiesData.companies)) {
        setEmpresas(companiesData.companies);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Error cargando datos:', error);
    }
  }

  async function cargarDispositivos() {
    try {
      setLoading(true);

      const token = localStorage.getItem('token');

      const response = await fetch('/api/admin/devices', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (data.success) {
        setDevices(data.devices || []);
      } else {
        alert(data.message || 'Error cargando dispositivos');
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Error cargando dispositivos:', error);
      alert('No fue posible cargar los dispositivos');
    } finally {
      setLoading(false);
    }
  }

  function actualizarCampo(campo, valor) {
    setForm({
      ...form,
      [campo]: valor
    });
  }

  function formatearFecha(fecha) {
    if (!fecha) return '—';

    return new Date(fecha).toLocaleString('es-CO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  function traducirEstado(status) {
    if (status === 'created') return 'Creado';
    if (status === 'moving') return 'En movimiento';
    if (status === 'stopped') return 'Detenido';
    if (status === 'online') return 'En línea';
    if (status === 'offline') return 'Desconectado';
    if (status === 'active') return 'Activo';
    if (status === 'inactive') return 'Inactivo';
    if (status === 'expired') return 'Licencia expirada';

    return status || 'Creado';
  }

  function traducirLicencia(status) {
    if (!status) return 'Pendiente';
    if (status === 'unlicensed') return 'Sin licencia';
if (status === 'suspended') return 'Suspendida';
    if (status === 'available') return 'Disponible';
    if (status === 'active') return 'Activa';
    if (status === 'expired') return 'Expirada';
    if (status === 'expiring') return 'Por vencer';

    return status;
  }

  function getLicenseStyle(status) {
    if (status === 'active') {
      return {
        ...badge,
        background: '#dcfce7',
        color: '#166534'
      };
    }

   if (
  status === 'expired' ||
  status === 'unlicensed' ||
  status === 'suspended'
) {
      return {
        ...badge,
        background: '#fee2e2',
        color: '#991b1b'
      };
    }

    if (status === 'expiring') {
      return {
        ...badge,
        background: '#ffedd5',
        color: '#c2410c'
      };
    }

    return licenseBadge;
  }
async function asignarLicencia(imei) {
  try {
    if (!imei) {
      alert('Este dispositivo no tiene IMEI válido');
      return;
    }

    const confirmar = window.confirm(
      `¿Asignar una licencia disponible al IMEI ${imei}?`
    );

    if (!confirmar) return;

    const token = localStorage.getItem('token');

    const response = await fetch(
      '/api/licenses/assign-device',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          imei
        })
      }
    );

    const data = await response.json();

    if (data.success) {
      alert('Licencia asignada correctamente');
      cargarDispositivos();
    } else {
      alert(data.message || 'Error asignando licencia');
    }
  } catch (error) {
      if (error?.name === 'AbortError') return;
    console.error(error);
    alert('No fue posible asignar la licencia');
  }
}

function seleccionarFoto(event) {
  const file = event.target.files?.[0];

  event.target.value = '';

  if (!file) return;

  if (!file.type.startsWith('image/')) {
    alert('Selecciona una imagen válida');
    return;
  }

  const maxSize = 10 * 1024 * 1024;

  if (file.size > maxSize) {
    alert('La fotografía no puede superar los 10 MB');
    return;
  }

  setPhotoFile(file);
  setPhotoEditorOpen(true);
}

function confirmarEdicionFoto(result) {
  if (photoPreview) {
    URL.revokeObjectURL(photoPreview);
  }

  const previewUrl = URL.createObjectURL(result.file);

  setPhotoPreview(previewUrl);
  setPhotoEditorOpen(false);

  /*
    Conservamos también scale/x/y para el siguiente
    paso, cuando generemos el archivo WebP definitivo.
  */
  setPhotoFile(result.file);
}

function eliminarFoto() {
  if (photoPreview) {
    URL.revokeObjectURL(photoPreview);
  }

  setPhotoFile(null);
  setPhotoPreview('');
  setPhotoEditorOpen(false);
}

function abrirEditarDispositivo(device) {
  setEditingDevice(device);

  setEditForm({
    name: device.name || '',
    imei: device.imei || '',
    plate: device.plate || '',
    protocol: device.protocol || '',
    company_id: device.company_id || '',
    admin_id: device.admin_id || '',
    user_id: device.user_id || ''
  });

  const existingPhoto =
    device.image_url ||
    device.vehicle_image_url ||
    device.photo_url ||
    device.photo ||
    device.image ||
    '';

setEditPhotoPreview(existingPhoto);
setEditPhotoFile(null);
setEditPhotoRemoved(false);

  setEditModalOpen(true);
}

async function guardarEdicionDispositivo() {
  try {
    if (!editingDevice?.id) {
      alert('No hay dispositivo seleccionado');
      return;
    }

    if (!editForm.name) {
      alert('El nombre del dispositivo es obligatorio');
      return;
    }

    if (!editForm.protocol) {
      alert('Debes seleccionar el protocolo del dispositivo');
      return;
    }

    const token = localStorage.getItem('token');

    // 1. Guardar datos del dispositivo
    const response = await fetch(
      `/api/devices/${editingDevice.id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
body: JSON.stringify({
  name: editForm.name,
  plate: editForm.plate,
  protocol: editForm.protocol
})
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      alert(
        data.message ||
        'Error actualizando dispositivo'
      );
      return;
    }

    // 2. Si seleccionamos una foto nueva,
    // subirla al servidor
    if (editPhotoFile) {
      const photoData = new FormData();

      photoData.append(
        'photo',
        editPhotoFile
      );

      const photoResponse = await fetch(
        `/api/devices/${editingDevice.id}/photo`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: photoData
        }
      );

      const photoResult =
        await photoResponse.json();

      if (
        !photoResponse.ok ||
        !photoResult.success
      ) {
        alert(
          photoResult.message ||
          'Los datos fueron guardados, pero hubo un error guardando la fotografía'
        );
        return;
      }
    }


    if (editPhotoRemoved && !editPhotoFile) {
  const deletePhotoResponse = await fetch(
    `/api/devices/${editingDevice.id}/photo`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  const deletePhotoResult =
    await deletePhotoResponse.json();

  if (
    !deletePhotoResponse.ok ||
    !deletePhotoResult.success
  ) {
    alert(
      deletePhotoResult.message ||
      'Los datos fueron guardados, pero hubo un error eliminando la fotografía'
    );
    return;
  }
}
    alert(
      'Dispositivo actualizado correctamente'
    );

    setEditModalOpen(false);
    setEditingDevice(null);

setEditPhotoFile(null);
setEditPhotoPreview('');
setEditPhotoEditorOpen(false);
setEditPhotoRemoved(false);

    await cargarDispositivos();

  } catch (error) {
      if (error?.name === 'AbortError') return;
    console.error(
      'Error actualizando dispositivo:',
      error
    );

    alert(
      'No fue posible actualizar el dispositivo'
    );
  }
}
async function archivarDispositivo() {
  try {
    if (!editingDevice?.id) {
      alert('No hay dispositivo seleccionado');
      return;
    }

    const nombre =
      editingDevice.name ||
      editForm.name ||
      'este dispositivo';

    const confirmar = window.confirm(
      `¿Estás seguro de archivar "${nombre}"?\n\n` +
      `IMEI: ${editingDevice.imei || editForm.imei || '—'}\n\n` +
      `El activo dejará de aparecer en la operación normal, ` +
      `pero conservará su información, histórico y configuración.\n\n` +
      `Esta acción podrá revertirse posteriormente desde Archivados.`
    );

    if (!confirmar) {
      return;
    }

    const token =
      localStorage.getItem('token');

    const response = await fetch(
      `/api/devices/${editingDevice.id}/archive`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          archived: true
        })
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      alert(
        data.message ||
        'No fue posible archivar el dispositivo'
      );

      return;
    }

    alert(
      `"${nombre}" fue archivado correctamente.`
    );

    setEditModalOpen(false);
    setEditingDevice(null);

    setEditPhotoFile(null);
    setEditPhotoPreview('');
    setEditPhotoEditorOpen(false);
    setEditPhotoRemoved(false);

    await cargarDispositivos();

  } catch (error) {
      if (error?.name === 'AbortError') return;
    console.error(
      'Error archivando dispositivo:',
      error
    );

    alert(
      'No fue posible archivar el dispositivo'
    );
  }
}
async function crearDispositivo() {
  try {
    if (!form.name || !form.imei) {
      alert(
        'Nombre del dispositivo e IMEI son obligatorios'
      );
      return;
    }

    if (!form.protocol) {
      alert(
        'Debes seleccionar el protocolo del dispositivo'
      );
      return;
    }

    const token =
      localStorage.getItem('token');

    /*
      Guardamos el IMEI antes de limpiar el formulario.

      Nos sirve también como respaldo para localizar
      el dispositivo recién creado si /api/add-device
      no devuelve directamente su ID.
    */
    const nuevoImei = form.imei;

    // ==================================================
    // 1. CREAR DISPOSITIVO
    // ==================================================

    const response = await fetch(
      '/api/add-device',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Authorization:
            `Bearer ${token}`
        },

        body: JSON.stringify(form)
      }
    );

    const data =
      await response.json();

    if (
      !response.ok ||
      !data.success
    ) {
      alert(
        data.message ||
        'Error creando dispositivo'
      );

      return;
    }

    /*
      Intentamos obtener el ID directamente
      de la respuesta del backend.

      Dejamos varias posibilidades porque todavía
      no vamos a modificar el backend hasta comprobar
      exactamente qué estructura devuelve.
    */
    let nuevoDeviceId =
      data.device?.id ||
      data.device_id ||
      data.deviceId ||
      data.id ||
      data.insertId ||
      null;

    // ==================================================
    // 2. SI HAY FOTO, NECESITAMOS EL ID
    // ==================================================

    if (photoFile) {

      /*
        Si /api/add-device no devolvió ID,
        consultamos los dispositivos y buscamos
        el recién creado por su IMEI.
      */
      if (!nuevoDeviceId) {
        const devicesResponse =
          await fetch(
            '/api/admin/devices',
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        const devicesData =
          await devicesResponse.json();

        if (
          devicesResponse.ok &&
          devicesData.success &&
          Array.isArray(
            devicesData.devices
          )
        ) {
          const nuevoDevice =
            devicesData.devices.find(
              (device) =>
                String(device.imei) ===
                String(nuevoImei)
            );

          nuevoDeviceId =
            nuevoDevice?.id || null;
        }
      }

      /*
        El dispositivo ya fue creado.
        Pero sin ID no podemos subir la fotografía.
      */
      if (!nuevoDeviceId) {
        alert(
          'El dispositivo fue creado, pero no fue posible obtener su ID para guardar la fotografía.'
        );

        await cargarDispositivos();

        return;
      }

      // ==================================================
      // 3. SUBIR FOTO DEL DISPOSITIVO RECIÉN CREADO
      // ==================================================

      const photoData =
        new FormData();

      photoData.append(
        'photo',
        photoFile
      );

      const photoResponse =
        await fetch(
          `/api/devices/${nuevoDeviceId}/photo`,
          {
            method: 'POST',

            headers: {
              Authorization:
                `Bearer ${token}`
            },

            body: photoData
          }
        );

      const photoResult =
        await photoResponse.json();

      if (
        !photoResponse.ok ||
        !photoResult.success
      ) {
        alert(
          photoResult.message ||
          'El dispositivo fue creado, pero hubo un error guardando la fotografía'
        );

        await cargarDispositivos();

        return;
      }
    }

    // ==================================================
    // 4. TODO CORRECTO
    // ==================================================

    alert(
      'Dispositivo creado correctamente'
    );

    setModalOpen(false);

    setForm({
      name: '',
      imei: '',
      plate: '',
      protocol: '',
      company_id: '',
      admin_id: '',
      user_id: ''
    });

    /*
      Liberamos el blob utilizado
      para la previsualización.
    */
    if (
      photoPreview &&
      photoPreview.startsWith('blob:')
    ) {
      URL.revokeObjectURL(
        photoPreview
      );
    }

    setPhotoFile(null);
    setPhotoPreview('');
    setPhotoEditorOpen(false);

    await cargarDispositivos();

  } catch (error) {
      if (error?.name === 'AbortError') return;
    console.error(
      'Error creando dispositivo:',
      error
    );

    alert(
      'No fue posible crear el dispositivo'
    );
  }
}

  const administradores =
    usuarios.filter((u) => u.role === 'administrador');

  const usuariosFinales =
    usuarios.filter((u) => u.role === 'usuario');

  return (
    <div style={{ ...wrapper, ...(isMobile ? { padding: '18px 14px 28px' } : {}) }}>
      <div style={{ ...header, ...(isMobile ? { flexDirection: 'column', alignItems: 'stretch', gap: 12 } : {}) }}>
        <div>
          <h2 style={title}>
            Administración de dispositivos
          </h2>

          <p style={subtitle}>
            Gestiona hardware GPS, IMEI, empresa,
            administrador, usuario asignado y licencia.
          </p>
        </div>

        {user.role !== 'usuario' && (
          <button
            style={primaryButton}
            onClick={() => setModalOpen(true)}
          >
            + Nuevo dispositivo
          </button>
        )}
      </div>

      <div style={{ ...tableBox, ...(isMobile ? { padding: 8, maxWidth: '100%', boxSizing: 'border-box' } : {}) }}>
        {loading ? (
          <div style={emptyState}>
            Cargando dispositivos...
          </div>
        ) : (
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>Nombre</th>
                <th style={th}>IMEI</th>
                <th style={th}>Empresa</th>
                <th style={th}>Administrador</th>
                <th style={th}>Usuario</th>
                <th style={th}>Licencia</th>
                <th style={th}>Vencimiento</th>
                <th style={th}>Estado</th>
                <th style={th}>Fecha creación</th>
             <th
  style={{
    ...th,
    position: 'sticky',
    right: 0,
    zIndex: 3,
    background: '#f8fafc',
    boxShadow: '-8px 0 12px rgba(15,23,42,0.04)'
  }}
>
  Acciones
</th>
              </tr>
            </thead>

            <tbody>
              {devices.length === 0 && (
                <tr>
                  <td style={td} colSpan="10">
                    No hay dispositivos registrados.
                  </td>
                </tr>
              )}

              {devices.map((device) => (
                <tr key={device.id}>
                  <td style={td}>
                    <strong>{device.name || '—'}</strong>
                  </td>

                  <td style={td}>
                    {device.imei || '—'}
                  </td>

                  <td style={td}>
                    {device.company_name || '—'}
                  </td>

                  <td style={td}>
                    {device.admin_name || '—'}
                  </td>

                  <td style={td}>
                    {device.user_name || '—'}
                  </td>

                  <td style={td}>
                    <span style={getLicenseStyle(device.license_status)}>
                      {traducirLicencia(device.license_status)}
                    </span>
                  </td>

                  <td style={td}>
                    {formatearFecha(device.license_expires_at)}
                  </td>

                  <td style={td}>
                    <span style={statusBadge}>
                      {traducirEstado(device.status)}
                    </span>
                  </td>

                  <td style={td}>
                    {formatearFecha(device.created_at)}
                  </td>

                 <td
  style={{
    ...td,
    position: 'sticky',
    right: 0,
    zIndex: 2,
    background: '#ffffff',
    boxShadow: '-8px 0 12px rgba(15,23,42,0.06)'
  }}
>
  <div style={actions}>
    {user.role !== 'usuario' && (
      <button
        style={smallButton}
        onClick={() =>
          abrirEditarDispositivo(device)
        }
      >
        Editar
      </button>
    )}
  </div>
</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modalOpen && (
        <div style={modalOverlay}>
          <div style={{ ...modalBox, ...(isMobile ? { width: 'calc(100vw - 24px)', maxHeight: 'calc(100dvh - 42px)', overflowY: 'auto', padding: 16, boxSizing: 'border-box' } : {}) }}>
            <h2 style={modalTitle}>
              Nuevo dispositivo
            </h2>

            <p style={modalText}>
             Registra un dispositivo GPS. Al crearlo, se activará automáticamente una licencia disponible del stock del usuario que lo crea.
            </p>

            <div style={{ ...formGrid, ...(isMobile ? { gridTemplateColumns: 'minmax(0, 1fr)', gap: 10 } : {}) }}>
              <Input
                label="Nombre dispositivo"
                value={form.name}
                onChange={(v) =>
                  actualizarCampo('name', v)
                }
              />

              <Input
                label="IMEI"
                value={form.imei}
                onChange={(v) =>
                  actualizarCampo('imei', v)
                }
              />

              <Input
                label="Placa / activo monitoreado"
                value={form.plate}
                onChange={(v) =>
                  actualizarCampo('plate', v)
                }
              />
              <Select
  label="Protocolo / integración"
  value={form.protocol}
  onChange={(v) =>
    actualizarCampo('protocol', v)
  }
  options={[
    {
      id: 'teltonika',
      name: 'Teltonika — Receptor directo MACCEZ'
    },
    {
      id: 'traccar',
      name: 'Otros dispositivos — Traccar'
    }
  ]}
  placeholder="Seleccionar protocolo"
/>
<div style={photoField}>
  <label style={labelStyle}>
    Foto del activo
    <span style={optionalLabel}>
      {' '}Opcional
    </span>
  </label>

  {photoPreview ? (
    <>
      <div style={photoPreviewBox}>
        <img
          src={photoPreview}
          alt="Activo"
          style={photoPreviewImage}
        />

        <div style={photoPreviewOverlay} />

        <strong style={photoVehicleName}>
          {form.name || 'Activo'}
        </strong>
      </div>

      <div style={photoActions}>
        <label style={photoActionButton}>
          Cambiar foto

          <input
            type="file"
            accept="image/*"
            onChange={seleccionarFoto}
            style={{ display: 'none' }}
          />
        </label>

        {photoFile && (
          <button
            type="button"
            style={photoActionButton}
            onClick={() =>
              setPhotoEditorOpen(true)
            }
          >
            Ajustar
          </button>
        )}

        <button
          type="button"
          style={deletePhotoButton}
          onClick={eliminarFoto}
        >
          Eliminar
        </button>
      </div>
    </>
  ) : (
    <label style={photoSelector}>
      <span style={photoPlus}>＋</span>

      <strong>
        Agregar fotografía
      </strong>

      <span style={photoSelectorText}>
        Selecciona una imagen del vehículo
      </span>

      <input
        type="file"
        accept="image/*"
        onChange={seleccionarFoto}
        style={{ display: 'none' }}
      />
    </label>
  )}
</div>

              {user.role === 'super_admin' && (
                <Select
                  label="Empresa"
                  value={form.company_id}
                  onChange={(v) =>
                    actualizarCampo('company_id', v)
                  }
                  options={empresas}
                  placeholder="Seleccionar empresa"
                />
              )}

              {(user.role === 'super_admin' ||
                user.role === 'admin_empresa') && (
                <Select
                  label="Administrador"
                  value={form.admin_id}
                  onChange={(v) =>
                    actualizarCampo('admin_id', v)
                  }
                  options={administradores}
                  placeholder="Seleccionar administrador"
                />
              )}

              <Select
                label="Usuario asignado"
                value={form.user_id}
                onChange={(v) =>
                  actualizarCampo('user_id', v)
                }
                options={usuariosFinales}
                placeholder="Seleccionar usuario"
              />
            </div>

           <div style={modalActions}>
              <button
                style={secondaryButton}
                onClick={() => setModalOpen(false)}
              >
                Cancelar
              </button>

              <button
                style={primaryButton}
                onClick={crearDispositivo}
              >
                Crear dispositivo
              </button>
            </div>
          </div>
        </div>
      )}
{editModalOpen && editingDevice && (
        <div style={modalOverlay}>
          <div style={{ ...modalBox, ...(isMobile ? { width: 'calc(100vw - 24px)', maxHeight: 'calc(100dvh - 42px)', overflowY: 'auto', padding: 16, boxSizing: 'border-box' } : {}) }}>
            <h2 style={modalTitle}>
              Editar dispositivo
            </h2>

            <p style={modalText}>
              Modifica la información del dispositivo.
            </p>

            <div style={{ ...formGrid, ...(isMobile ? { gridTemplateColumns: 'minmax(0, 1fr)', gap: 10 } : {}) }}>
              <Input
                label="Nombre dispositivo"
                value={editForm.name}
                onChange={(v) =>
                  setEditForm({
                    ...editForm,
                    name: v
                  })
                }
              />

              <div>
                <label style={labelStyle}>
                  IMEI
                </label>

                <input
                  value={editForm.imei}
                  disabled
                  style={{
                    ...inputStyle,
                    background: '#f1f5f9',
                    color: '#64748b',
                    cursor: 'not-allowed'
                  }}
                />
              </div>

              <Input
                label="Placa / activo monitoreado"
                value={editForm.plate}
                onChange={(v) =>
                  setEditForm({
                    ...editForm,
                    plate: v
                  })
                }
              />

              <Select
                label="Protocolo / integración"
                value={editForm.protocol}
                onChange={(v) =>
                  setEditForm({
                    ...editForm,
                    protocol: v
                  })
                }
                options={[
                  {
                    id: 'teltonika',
                    name: 'Teltonika — Receptor directo MACCEZ'
                  },
                  {
                    id: 'traccar',
                    name: 'Otros dispositivos — Traccar'
                  }
                ]}
                placeholder="Seleccionar protocolo"
              />

             <div style={photoField}>
  <label style={labelStyle}>
    Foto del activo
    <span style={optionalLabel}>
      {' '}Opcional
    </span>
  </label>

  {editPhotoPreview ? (
    <>
      <div style={photoPreviewBox}>
        <img
          src={editPhotoPreview}
          alt="Activo"
          style={photoPreviewImage}
        />

        <div style={photoPreviewOverlay} />

        <strong style={photoVehicleName}>
          {editForm.name || 'Activo'}
        </strong>
      </div>

      <div style={photoActions}>
        <label style={photoActionButton}>
          Cambiar foto

          <input
            type="file"
            accept="image/*"
            onChange={(event) => {
              const file = event.target.files?.[0];

              event.target.value = '';

              if (!file) return;

              if (!file.type.startsWith('image/')) {
                alert('Selecciona una imagen válida');
                return;
              }

              const maxSize = 10 * 1024 * 1024;

              if (file.size > maxSize) {
                alert(
                  'La fotografía no puede superar los 10 MB'
                );
                return;
              }

              setEditPhotoFile(file);
              setEditPhotoEditorOpen(true);
            }}
            style={{ display: 'none' }}
          />
        </label>

       <button
  type="button"
  style={deletePhotoButton}
  onClick={() => {
    if (
      editPhotoPreview &&
      editPhotoPreview.startsWith('blob:')
    ) {
      URL.revokeObjectURL(editPhotoPreview);
    }

    setEditPhotoFile(null);
    setEditPhotoPreview('');
    setEditPhotoRemoved(true);
  }}
>
  Eliminar
</button>
      </div>
    </>
  ) : (
    <label style={photoSelector}>
      <span style={photoPlus}>＋</span>

      <strong>
        Agregar fotografía
      </strong>

      <span style={photoSelectorText}>
        Selecciona una imagen del vehículo
      </span>

      <input
        type="file"
        accept="image/*"
        onChange={(event) => {
          const file = event.target.files?.[0];

          event.target.value = '';

          if (!file) return;

          if (!file.type.startsWith('image/')) {
            alert('Selecciona una imagen válida');
            return;
          }

          const maxSize = 10 * 1024 * 1024;

          if (file.size > maxSize) {
            alert(
              'La fotografía no puede superar los 10 MB'
            );
            return;
          }

          setEditPhotoFile(file);
          setEditPhotoEditorOpen(true);
        }}
        style={{ display: 'none' }}
      />
    </label>
  )}
</div>

       <div
  style={{
    gridColumn: '1 / -1',
    padding: '12px',
    borderRadius: '10px',
    background: '#f1f5f9',
    color: '#334155',
    fontSize: '13px'
  }}
>
  Para cambiar la empresa, el administrador o el usuario
  asignado, utiliza «Mover activo» en Administración.
</div>
            </div>

<div style={modalActions}>
  <button
    type="button"
    style={archiveButton}
    onClick={archivarDispositivo}
  >
    Archivar activo
  </button>

  <button
    type="button"
    style={secondaryButton}
    onClick={() => {
      setEditModalOpen(false);
      setEditingDevice(null);
    }}
  >
    Cancelar
  </button>

  <button
    type="button"
    style={primaryButton}
    onClick={guardarEdicionDispositivo}
  >
    Guardar cambios
  </button>
</div>
          </div>
        </div>
      )}

      <VehiclePhotoEditor
  open={photoEditorOpen}
  imageFile={photoFile}
  onCancel={() => setPhotoEditorOpen(false)}
  onConfirm={confirmarEdicionFoto}
/>
<VehiclePhotoEditor
  open={editPhotoEditorOpen}
  imageFile={editPhotoFile}
  onCancel={() => setEditPhotoEditorOpen(false)}
  onConfirm={(result) => {
    if (
      editPhotoPreview &&
      editPhotoPreview.startsWith('blob:')
    ) {
      URL.revokeObjectURL(editPhotoPreview);
    }

    const previewUrl =
      URL.createObjectURL(result.file);

    setEditPhotoFile(result.file);
    setEditPhotoPreview(previewUrl);
    setEditPhotoEditorOpen(false);
  }}
/>

    </div>
  );
}

function Input({ label, value, onChange }) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>

      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={inputStyle}
      />
    </div>
  );
}

function Select({
  label,
  value,
  onChange,
  options,
  placeholder
}) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={inputStyle}
      >
        <option value="">
          {placeholder}
        </option>

        {options.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
            {item.email ? ` - ${item.email}` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}

const wrapper = {
  padding: '28px 40px 40px'
};

const header = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px'
};

const title = {
  margin: 0,
  fontSize: '24px',
  color: '#0f172a'
};

const subtitle = {
  marginTop: '8px',
  color: '#64748b',
  maxWidth: '760px'
};

const primaryButton = {
  background: '#2563eb',
  border: 'none',
  color: '#ffffff',
  padding: '12px 18px',
  borderRadius: '12px',
  cursor: 'pointer',
  fontWeight: '800'
};

const secondaryButton = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  color: '#334155',
  padding: '12px 18px',
  borderRadius: '12px',
  cursor: 'pointer',
  fontWeight: '800'
};
const archiveButton = {
  background: '#ffffff',
  border: '1px solid #fecaca',
  color: '#b91c1c',
  padding: '12px 18px',
  borderRadius: '12px',
  cursor: 'pointer',
  fontWeight: '800',
  marginRight: 'auto'
};
const tableBox = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '18px',
  padding: '22px',
  boxShadow: '0 8px 24px rgba(15,23,42,0.06)',
  overflowX: 'auto'
};

const table = {
  width: '100%',
  borderCollapse: 'collapse'
};

const th = {
  textAlign: 'left',
  padding: '16px',
  color: '#64748b',
  fontSize: '13px',
  fontWeight: '800',
  background: '#f8fafc'
};

const td = {
  padding: '16px',
  borderTop: '1px solid #f1f5f9',
  color: '#334155',
  fontSize: '14px',
  whiteSpace: 'nowrap'
};

const emptyState = {
  padding: '18px',
  color: '#64748b',
  fontWeight: '700'
};

const badge = {
  padding: '5px 12px',
  borderRadius: '999px',
  fontSize: '12px',
  fontWeight: '800'
};

const statusBadge = {
  ...badge,
  background: '#eef2ff',
  color: '#3730a3'
};

const licenseBadge = {
  ...badge,
  background: '#fef3c7',
  color: '#92400e'
};

const actions = {
  display: 'flex',
  gap: '8px'
};

const smallButton = {
  border: '1px solid #e2e8f0',
  background: '#ffffff',
  color: '#334155',
  padding: '8px 10px',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: '800'
};

const licenseButton = {
  ...smallButton,
  border: '1px solid #bfdbfe',
  background: '#eff6ff',
  color: '#1d4ed8'
};

const modalOverlay = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,23,42,0.45)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999
};

const modalBox = {
  width: '760px',
  background: '#ffffff',
  borderRadius: '24px',
  padding: '30px',
  boxShadow: '0 24px 80px rgba(0,0,0,0.25)'
};

const modalTitle = {
  margin: 0,
  fontSize: '26px',
  color: '#0f172a'
};

const modalText = {
  color: '#64748b',
  marginTop: '8px'
};

const formGrid = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  marginTop: '24px'
};

const labelStyle = {
  display: 'block',
  fontSize: '13px',
  fontWeight: '800',
  color: '#64748b',
  marginBottom: '8px'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '12px',
  border: '1px solid #e2e8f0',
  fontWeight: '700'
};

const modalActions = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '26px'
};


const photoField = {
  gridColumn: '1 / -1'
};

const optionalLabel = {
  color: '#94a3b8',
  fontWeight: '600'
};

const photoSelector = {
  minHeight: '105px',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  gap: '5px',

  border: '1.5px dashed #cbd5e1',
  borderRadius: '14px',

  background: '#f8fafc',
  color: '#334155',

  cursor: 'pointer'
};

const photoPlus = {
  color: '#2563eb',
  fontSize: '25px',
  lineHeight: 1
};

const photoSelectorText = {
  color: '#94a3b8',
  fontSize: '11px'
};

const photoPreviewBox = {
  position: 'relative',

  width: '148px',
  height: '96px',

  overflow: 'hidden',

  borderRadius: '14px',

  background: '#07101d',

  border:
    '1px solid rgba(65,158,255,0.7)'
};

const photoPreviewImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block'
};

const photoPreviewOverlay = {
  position: 'absolute',
  inset: 0,

  background:
    'linear-gradient(180deg, transparent 45%, rgba(2,8,18,.8) 100%)'
};

const photoVehicleName = {
  position: 'absolute',

  left: '9px',
  bottom: '7px',

  zIndex: 2,

  color: '#ffffff',

  fontSize: '12px',
  fontWeight: '900'
};

const photoActions = {
  display: 'flex',
  flexWrap: 'wrap',

  gap: '8px',

  marginTop: '9px'
};

const photoActionButton = {
  padding: '7px 10px',

  border: '1px solid #dbe3ef',
  borderRadius: '9px',

  background: '#ffffff',
  color: '#334155',

  fontSize: '11px',
  fontWeight: '800',

  cursor: 'pointer'
};

const deletePhotoButton = {
  ...photoActionButton,

  color: '#b91c1c',
  border: '1px solid #fecaca'
};
export default DevicesAdminPage;
